import { Component, OnInit, Input } from '@angular/core';
import { ModalController} from '@ionic/angular';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { WorkItem } from '../models/work-item';
import { ApiService } from '../services/api.service';
import { ProductsService } from '../products.service';

import { Router } from '@angular/router';

import { CurrencyService } from '../currency-service.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-work-item-add',
  templateUrl: './work-item-add.component.html',
  styleUrls: ['./work-item-add.component.scss']
})
export class WorkItemAddComponent implements OnInit {

  @Input() currencyCode: string;

  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;
  workItemToAdd: WorkItem;

  selectedAccount: any;
  accountCurrency: string = "GBP";
  currentBusiness: any;

  // This raw rate is used as typed by user
  rate: number;

  // Tax name
  taxName: any;

  constructor(
    public modalCtrl: ModalController, 
    public formBuilder: UntypedFormBuilder, 
    public apiService: ApiService, 
    public productsService: ProductsService, 
    public router: Router, 
    private currencyService: CurrencyService,
    public authService: AuthService) { }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    this.rate = 0;

    // Build Product Form
    this.ionicForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      description: [''],
      rate: [this.currencyService.formatCurrency(this.rate, this.accountCurrency)],
      quantity: [1],
      hasTax: [false],
      taxRate: [20],
      saveForFuture: false
    });

    // Get Account currency to format the payment amounts
    this.authService.getSelectedAccount().then((account) => {
      this.selectedAccount = account;
      this.accountCurrency = this.selectedAccount.currency;

      // Update ionic form with currency
      this.ionicForm.value.rate = this.currencyService.formatCurrency(this.rate, this.accountCurrency);
    });

    // Choose a business for the product
    // Get businesses and if we have 1 business, then pre-populate the tax info
    this.apiService.getBusinessList().subscribe(response => {
      if (response.length == 1) {
        this.ionicForm.patchValue(
          {
            hasTax: response[0].hasTax,
            taxRate: response[0].taxRate
          }
        );

        // Set current business
        this.currentBusiness = response[0];

        // Tax name
        this.taxName = response[0].taxName;
      }
    });

    // Create WorkItem Model
    this.workItemToAdd = new WorkItem();
  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  private prepareSave(): WorkItem {
    var newModel = new WorkItem().deserialize(this.ionicForm.value);
    return newModel;
  }

  totalPreview() {
    return this.workItemToAdd.totalPreview(this.rate, this.ionicForm.value.quantity, this.ionicForm.value.hasTax, this.ionicForm.value.taxRate);
  }

  subTotalPreview() {
    return this.workItemToAdd.subTotalPreview(this.rate, this.ionicForm.value.quantity);
  }

  submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values for a work item.')
      return false;
    } else {

      // Add the raw unformatted rate into the form
      this.ionicForm.value.rate = this.rate;

      // Update WorkItem model with form
      const newWorkItem = this.workItemToAdd.deserialize(this.ionicForm.value);

      // If.... the save slider is ON we should save it as a product from here
      if (this.ionicForm.value.saveForFuture) {
        console.log("Saving Product...");

        var newProduct = this.ionicForm.value

        // Add the business ID
        newProduct.businessId = this.currentBusiness.id;

        // API Save
        this.productsService.createItem(newProduct).subscribe((product) => {
          console.log(product);
        });
      }

      // Close the modal
      this.modalCtrl.dismiss(newWorkItem);
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }

  formatCurrency(event: any) {
    // CurrencyService handles the updating of the value through the event
    // this.rate is us maintaing the user raw input for saving via the API
    this.rate = parseInt(this.currencyService.formatCurrencyEvent(event, this.currencyCode));
  }

}
